module.exports = __webpack_public_path__ + "img/Computer Networks.cc29706c.svg";